import { render } from "./HeadImage.vue?vue&type=template&id=1f9613e6&scoped=true&lang=html"
import script from "./HeadImage.vue?vue&type=script&lang=js"
export * from "./HeadImage.vue?vue&type=script&lang=js"

import "./HeadImage.vue?vue&type=style&index=0&id=1f9613e6&lang=css&scoped=true"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9613e6"]])

export default __exports__